document.addEventListener( 'DOMContentLoaded', () => {
	const toolbarEle = document.getElementsByClassName( 'toolbar' );
	const pageID = toolbarEle[ 0 ].getAttribute( 'page-id' );

	const frontCommentClass = 'mdspan-front-comment';
	const frontBoardPrefix = 'el_front_';
	document
		.querySelector( '.entry-content' )
		.addEventListener( 'mouseup', ( e ) => {
			if (
				document.body.classList.contains( 'single-post' ) ||
				document.body.classList.contains( 'single-post' )
			) {
				const restrictedCommentCountTop = document.querySelector(
					'.cf-front-comment-count_wrap'
				);
				if (
					restrictedCommentCountTop &&
					restrictedCommentCountTop.contains( e.target )
				) {
					return;
				}
				const selection = window.getSelection();
				selectVal = selection;
				if ( selection.toString() === '' ) {
					return;
				}
				// restrict for multiple selected li tag
				if ( selection.rangeCount > 0 ) {
					const range = selection.getRangeAt( 0 );
					const selectedContent = range.cloneContents();

					const div = document.createElement( 'div' );
					div.appendChild( selectedContent );
					const selectedHTML = div.innerHTML;

					// Create a temporary container to parse the HTML
					const tempContainer = document.createElement( 'div' );
					tempContainer.innerHTML = selectedHTML;

					// Count the number of <li> tags
					const liTags = tempContainer.getElementsByTagName( 'li' );
					const liCount = liTags?.length;

					if ( liCount > 1 ) {
						return;
					}
				}
				const selectionRect = selection
					.getRangeAt( 0 )
					.getBoundingClientRect();
				const toolbarRect = toolbarEle[ 0 ].getBoundingClientRect();
				const distanceFromTop = window.scrollY;
				let top =
					selectionRect.top +
					distanceFromTop -
					toolbarRect.height -
					12;
				let left =
					selectionRect.left +
					( selectionRect.width - toolbarRect.width ) / 2;
				let arrowDirection = 'bottom';

				if ( top < 0 ) {
					top =
						selectionRect.top +
						distanceFromTop +
						selectionRect.height +
						12;
					left = selectionRect.left;
					arrowDirection = 'top';
				}

				toolbarEle[ 0 ].classList.remove( 'toolbar--bottom' );
				toolbarEle[ 0 ].classList.remove( 'toolbar--top' );
				toolbarEle[ 0 ].classList.add( `toolbar--${ arrowDirection }` );
				toolbarEle[ 0 ].style.transform = `translate(${ left }px, ${ top }px)`;
				toolbarEle[ 0 ].style.opacity = 1;
				Array.from(
					document.querySelectorAll( '.mdspan-front-comment' )
				).forEach( ( el ) =>
					el.classList.remove( 'mdspan-front-comment' )
				);
			}
		} );

	document
		.getElementById( 'cf-front-cancel' )
		?.addEventListener( 'click', function () {
			document.querySelector(
				'.cf-front-comment-wrapper'
			).style.transform = 'translateX(100%)';

			Array.from(
				document.querySelectorAll( '.mdspan-front-comment' )
			).forEach( ( el ) =>
				el.classList.remove( 'mdspan-front-comment' )
			);
		} );

	document.addEventListener( 'click', function ( e ) {
		const cf_front_comment = document.getElementById(
			'cf_front_comment_wrapper'
		);
		if ( cf_front_comment ) {
			const cfFrontCommentStyle =
				window?.getComputedStyle( cf_front_comment );

			// Get the transform value
			const transformValue = cfFrontCommentStyle?.transform;

			// Extract the translateX value
			let translateX = 0;
			if ( transformValue !== 'none' ) {
				const matrixValues = transformValue
					.match( /matrix.*\((.+)\)/ )[ 1 ]
					.split( ', ' );
				translateX = parseFloat( matrixValues[ 4 ] );
			}

			if ( ! cf_front_comment.contains( e.target ) && translateX == 0 ) {
				document.querySelector(
					'.cf-front-comment-wrapper'
				).style.transform = 'translateX(100%)';

				Array.from(
					document.querySelectorAll( '.mdspan-front-comment' )
				).forEach( ( el ) =>
					el.classList.remove( 'mdspan-front-comment' )
				);
			}
		}
	} );

	document
		.getElementById( 'cf-front-comment-count' )
		?.addEventListener( 'click', function () {
			document.querySelector(
				'.cf-front-comment-wrapper'
			).style.transform = 'translateX(0px)';
			document.querySelector(
				'.cf-front-comment-inner-wrapper'
			).style.display = 'block';
		} );
	document
		.getElementById( 'cf-front-comment-count-top' )
		?.addEventListener( 'click', function () {
			document.querySelector(
				'.cf-front-comment-wrapper'
			).style.transform = 'translateX(0px)';
			document.querySelector(
				'.cf-front-comment-inner-wrapper'
			).style.display = 'block';
		} );

	document.addEventListener( 'selectionchange', () => {
		const selection = window.getSelection().toString();
		if ( ! selection ) {
			toolbarEle[ 0 ].style.opacity = '0';
		}

		const selectedComments = document.querySelectorAll(
			'.cf-front-highlight'
		);
		selectedComments.forEach(
			( singleComment ) =>
				( singleComment.outerHTML = singleComment.innerText )
		);
	} );

	const elements = document.querySelectorAll( '.cf_comment_front' );
	Array.from( elements ).forEach( ( button, index ) => {
		button.addEventListener( 'click', ( e ) => {
			//toolbarEle[0].style.opacity = '0';
			const selectedText = window.getSelection().toString();
			const commentBoardDatatext = frontBoardPrefix + Date.now();
			cfWrapSelectedText( frontCommentClass, commentBoardDatatext );
			cfBoardDisplay( selectedText, commentBoardDatatext );
		} );
	} );

	const commentform = jQuery( '.cf-front-comment-wrapper #commentform' ); // find the comment form
	commentform.prepend( '<div id="comment-status" ></div>' ); // add info panel before the form to provide feedback or errors
	const statusdiv = jQuery( '#comment-status' ); // define the infopanel

	commentform.submit( function ( event ) {
		event.stopImmediatePropagation();

		//serialize and store form data in a variable
		const formdata = commentform.serialize();
		//Add a status message
		statusdiv.html( '<p>Processing...</p>' );
		//Extract action URL from commentform
		const formurl = commentform.attr( 'action' );
		//Post Form with data
		jQuery.ajax( {
			type: 'post',
			url: formurl,
			data: formdata,
			error( XMLHttpRequest, textStatus, errorThrown ) {
				statusdiv.html(
					'<p class="ajax-error" >You might have left one of the fields blank, or be posting too quickly</p>'
				);
			},
			success( data, textStatus ) {
				if ( data == 'success' || textStatus == 'success' ) {
					statusdiv.html(
						'<p class="ajax-success" >Thanks for your comment. We appreciate your response.</p>'
					);
					const commentData = {
						action: 'icfp_add_front_comment',
						nonce: cf_public_nonce.nonce,
						selection: document.querySelector(
							'.mdspan-front-comment'
						)?.innerHTML,
						pageID,
						commentText: document.querySelector(
							'.cf-front-comment-wrapper #comment'
						).value,
					};
					jQuery.post(
						cf_public_localizer.ajax_url,
						commentData,
						function ( data ) {
							if (
								document.querySelector(
									'.mdspan-front-comment'
								)
							) {
								document.querySelector(
									'.mdspan-front-comment'
								).outerHTML = document.querySelector(
									'.mdspan-front-comment'
								)?.innerHTML;
							}

							cfHideFrontCommentBoard();

							Array.from(
								document.querySelectorAll(
									'.mdspan-front-comment'
								)
							)?.forEach( ( el ) =>
								el.classList.remove( 'mdspan-front-comment' )
							);
						}
					);
				} else {
					statusdiv.html(
						'<p class="ajax-error" >Please wait a while before posting your next comment</p>'
					);
					commentform.find( 'textarea[name=comment]' ).val( '' );
				}
			},
		} );

		return false;
	} );
} );
